export default {
  view: 'supplier.view_department',
  add: 'supplier.add_department',
  change: 'supplier.change_department',
  delete: 'supplier.delete_department',
  export_products: 'supplier.export_department_products',
  import_products: 'supplier.import_department_products',
};
